<template>
  <div class="xc-radio-wrap">
    <div class="xc-radio-group">
      <div
        class="xc-radio-item"
        v-for="(item, index) in newRadioValue"
        :key="index"
        :data-index="index"
        :data-value="item.value"
        :data-id="item.id"
        @click="selectRadio"
      >
        <div :class="(item.active?'xc-radio-select':'xc-radio-but')"></div>
        <div class="xc-radio-text">{{item.text}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "XcRadio",
  props: {
    // 步骤文字
    radioValue: {
      type: Array,
      default: () => {
        return [
          {
            text: "选项1",
            value: "0",
            id: 1,
            active: true
          },
          {
            text: "选项2",
            value: "1",
            id: 2,
            active: false
          },
        ];
      }
    }
  },
  data() {
    return {
      newRadioValue: this.radioValue // ①创建props属性active的副本--myActive
    };
  },
  watch: {
      radioValue(val) {
          this.newRadioValue = val; //②监听外部对props属性active的变更，并同步到组件内的data属性myResult中
      },
      // myActive(val){
      //     this.$emit("on-active-change",val.active); //③组件内对myActive变更后向外部发送事件通知
      // }
  },

  methods: {
    selectRadio(e) {
        let { index, value } = e.currentTarget.dataset
        const radioValue = [...this.newRadioValue];

        for (let item of radioValue) {
            item.active = false;
        }

        radioValue[index].active = true

        this.newRadioValue = radioValue
        this.$emit("radio-fun", value)
    }
  }
};
</script>

<style lang="scss" scoped>
.xc-radio-group {
  display: flex;
  align-items: center;
}

.xc-radio-item {
  display: flex;
  align-items: center;
  margin-right: 26px;
  font-size: 14px;
  color: #6e7a90;
  cursor: pointer;
}

.xc-radio-but {
  width: 16px;
  height: 16px;
  border: solid 1px #cfd5e0;
  border-radius: 50%;
  margin-right: 8px;
}

.xc-radio-select {
  width: 16px;
  height: 16px;
  border: solid 1px #cfd5e0;
  position: relative;
  border-radius: 50%;
  margin-right: 8px;
}

.xc-radio-select::before {
  content: "";
  width: 10px;
  height: 10px;
  background: #507dde;
  border-radius: 50%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
